var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#089b80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1A7.5 7.5 0 1016 8.5 7.5 7.5 0 008.5 1m0 16A8.5 8.5 0 1117 8.5 8.51 8.51 0 018.5 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5a1 1 0 111 1 1 1 0 01-1-1m1 9a.5.5 0 00.5-.5v-6a.5.5 0 00-1 0v6a.5.5 0 00.5.5"
  }))));
}
SvgInfo.displayName = 'Info';
export default SvgInfo;